module.exports = __webpack_public_path__ + "static/018-ae9e0d9746d48f7691f452c72f4c4c02.jpg";